import useResizeObserver from 'resize-observer-hook';

import { useMetaContext } from '../../base';
import { GeoChartBodyPicture } from './GeoChartBodyPicture';

export const GeoChartBodyPictureWrapper = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ref, _, height] = useResizeObserver<HTMLDivElement>();
    const meta = useMetaContext();

    return (
        <div className="flex-grow overflow-visible relative" ref={ref}>
            {ref !== undefined && meta.picture !== undefined ? (
                <GeoChartBodyPicture width={meta.picture.width} height={height} />
            ) : null}
        </div>
    );
};
